/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { truncateHgvsP3 } from "../../../../components/TruncatedText/helpers";
import TruncatedText from "../../../../components/TruncatedText/TruncatedText";

/**
 * Displays protein value using item's `hgvs_p3` field in the General Information component.
 * Examples:
 *  - p.(Phe612_Gly613insProGluTyrGluTyrAspLeuLysTrpGluPheProArgGluAsnLeuGluPhe)?
 *  - p.(Phe612_Gly613insPro...Phe)?
 */

const ProteinValue = ({ isFLT3ITD, pValue }) => {
  if (!pValue) return <span>-</span>;

  const originalValue = pValue;
  const truncatedValue = truncateHgvsP3(pValue);
  if (isFLT3ITD && truncatedValue !== originalValue) {
    return (
      <TruncatedText
        truncatedText={truncatedValue}
        originalText={originalValue}
      />
    );
  }
  return originalValue;
};

ProteinValue.propTypes = {
  isFLT3ITD: PropTypes.bool.isRequired,
  pValue: PropTypes.string,
};

ProteinValue.defaultProps = {
  pValue: null,
};

export default React.memo(ProteinValue);
